"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _oxygenButton = _interopRequireDefault(require("@8x8/oxygen-button"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var alignMap = {
  left: 'flex-start',
  right: 'flex-end'
};

function getModalFooterPadding(_ref) {
  var theme = _ref.theme,
      isSmall = _ref.isSmall;
  var paddingHorizontal = isSmall ? theme.footerPaddingSmallHorizontal : theme.footerPaddingHorizontal;
  return "".concat(paddingHorizontal, " ").concat(theme.footerPaddingVertical);
}

var FooterContainer = _styledComponents["default"].div.attrs(function (_ref2) {
  var testId = _ref2.testId;
  return Object.assign({}, (0, _oxygenConfig.getTestAttributes)(testId));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  padding: ", ";\n  box-shadow: ", ";\n\n  ", " {\n    margin-left: ", ";\n  }\n\n  ", ":first-child {\n    margin-left: 0;\n  }\n"])), function (_ref3) {
  var align = _ref3.align;
  return alignMap[align] || align;
}, function (props) {
  return getModalFooterPadding(props);
}, function (_ref4) {
  var hasBorderTop = _ref4.hasBorderTop,
      theme = _ref4.theme;
  return hasBorderTop ? "inset ".concat(theme.footerShadowSize, " ").concat(theme.footerShadowColor) : 'none';
}, _oxygenButton["default"].getStyledContainer(), function (_ref5) {
  var theme = _ref5.theme,
      hasButtonSpacing = _ref5.hasButtonSpacing;
  return hasButtonSpacing ? theme.footerButtonSpacing : 0;
}, _oxygenButton["default"].getStyledContainer());

var _default = FooterContainer;
exports["default"] = _default;